import { BestLimits, OrderBookPriceRange } from "src/Interfaces/orderInterfaces";
import { OrderBookCellField } from "./orderBookHighlights";

export const isOrderBookPriceOutsideRange = (
  price: number | null | undefined,
  range?: OrderBookPriceRange | null,
): boolean => {
  const min = range?.minPricePermit;
  const max = range?.maxPricePermit;
  return price != null && Number.isFinite(price) && price > 0 &&
    min != null && max != null && Number.isFinite(min) &&
    Number.isFinite(max) && min > 0 && max >= min &&
    (price < min || price > max);
};

// Count, volume and price of one side are greyed together when that side's price is out of range.
export const isOrderBookCellOutsideRange = (
  row: BestLimits,
  field: OrderBookCellField,
  range?: OrderBookPriceRange | null,
): boolean =>
  isOrderBookPriceOutsideRange(field.endsWith("Dem") ? row.pMeDem : row.pMeOf, range);
